import { QueryOperation, SearchQuery } from "../code/search-query/search-query";
import {
  buildSearchQuery,
  comboboxValue,
  QueryFieldMapping,
} from "../code/search-query/query-mapper";
import { DataColumn } from "../controls/Data.default";
import { DynamicSchema } from "../controls/DynamicForm.default";
import { InputObject } from "../controls/default";
import { createSearchRequest } from "../hooks/useSearchRequest";
import { getAssetTypes } from "../repository/data.repository";

export interface AssetSubtypesViewForm {
  readonly name: string;
  readonly description: string;
  readonly assetType?: InputObject;
}

export const assetSubtypesViewColumns: DataColumn[] = [
  {
    title: "Name",
    key: "name",
    width: 192,
    sort: true,
    defaultSort: "asc",
    fixed: "left",
  },
  {
    title: "Asset Type",
    key: "assetTypeName",
    width: 160,
    sort: true,
  },
  {
    title: "Description",
    key: "description",
    width: 288,
    sort: true,
  },
  {
    title: "Assets",
    key: "assetsCount",
    width: 110,
    sort: true,
  },
];

const assetSubtypesQueryMappings: QueryFieldMapping[] = [
  { formField: "name" },
  { formField: "description" },
  {
    formField: "assetType",
    queryField: "assetTypeUid",
    operation: QueryOperation.Equal,
    transform: comboboxValue,
  },
];

export const mapAssetSubtypesViewQuery = (
  values: AssetSubtypesViewForm,
): SearchQuery => buildSearchQuery(values, assetSubtypesQueryMappings);

export const assetSubtypesSearchSchema: DynamicSchema = {
  groups: [
    {
      controls: [
        {
          type: "combobox",
          name: "assetType",
          label: "Asset Type",
          request: createSearchRequest(getAssetTypes, "name"),
        },
        { type: "textbox", name: "name", label: "Name" },
        { type: "textbox", name: "description", label: "Description" },
      ],
    },
  ],
};
